import Footer from '@/components/Footer';
import RightContent from '@/components/RightContent';
import { currentUser as queryCurrentUser } from '@/services/system';
import type { Settings as LayoutSettings } from '@ant-design/pro-components';
// import { SettingDrawer } from '@ant-design/pro-components';
import type { RequestConfig, RunTimeLayoutConfig } from '@umijs/max';
import { history } from '@umijs/max';
import defaultSettings from '../config/defaultSettings';
import { errorConfig } from './requestErrorConfig';

// 前端登录页面路由
const LOGIN_PATH = '/login';
// 后端登录接口
const API_LOGIN = '/api/system/login';

interface InitialState {
  settings?: Partial<LayoutSettings>;
  currentUser?: API.SystemUser;
  fetchUserInfo?: () => Promise<any>;
}

/**
 * @see  https://umijs.org/zh-CN/plugins/plugin-initial-state
 * */
export async function getInitialState(): Promise<InitialState> {
  const fetchUserInfo = async () => {
    try {
      const result = await queryCurrentUser({
        skipErrorHandler: true,
      });
      return result.data;
    } catch (error) {
      history.push(LOGIN_PATH);
    }
    return undefined;
  };

  // 如果不是登录页面，执行
  const { location } = history;
  if (location.pathname !== LOGIN_PATH) {
    const currentUser = await fetchUserInfo();
    return {
      fetchUserInfo,
      currentUser,
      settings: defaultSettings as LayoutSettings,
    };
  }

  return {
    fetchUserInfo,
    settings: defaultSettings as LayoutSettings,
  };
}

// ProLayout 支持的api https://procomponents.ant.design/components/layout
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const layout: RunTimeLayoutConfig = ({ initialState, setInitialState }) => {
  return {
    rightContentRender: () => <RightContent />,
    footerRender: () => <Footer />,
    onPageChange: () => {
      const { location } = history;
      // 如果没有登录，重定向到 login
      if (!initialState?.currentUser && location.pathname !== LOGIN_PATH) {
        history.push(LOGIN_PATH);
      }
    },
    layoutBgImgList: [
      {
        src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/D2LWSqNny4sAAAAAAAAAAAAAFl94AQBr',
        left: 85,
        bottom: 100,
        height: '303px',
      },
      {
        src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/C2TWRpJpiC0AAAAAAAAAAAAAFl94AQBr',
        bottom: -68,
        right: -45,
        height: '303px',
      },
      {
        src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/F6vSTbj8KpYAAAAAAAAAAAAAFl94AQBr',
        bottom: 0,
        left: 0,
        width: '331px',
      },
    ],
    // links: isDev
    //   ? [
    //       <Link key="openapi" to="/umi/plugin/openapi" target="_blank">
    //         <LinkOutlined />
    //         <span>OpenAPI 文档</span>
    //       </Link>,
    //     ]
    //   : [],
    menuHeaderRender: undefined,
    // 自定义 403 页面
    // unAccessible: <div>unAccessible</div>,
    // 增加一个 loading 的状态
    // childrenRender: (children) => {
    //   // if (initialState?.loading) return <PageLoading />;
    //   return (
    //     <>
    //       {children}
    //       <SettingDrawer
    //         disableUrlParams
    //         enableDarkTheme
    //         settings={initialState?.settings}
    //         onSettingChange={(settings) => {
    //           setInitialState((preInitialState) => ({
    //             ...preInitialState,
    //             settings,
    //           }));
    //         }}
    //       />
    //     </>
    //   );
    // },
    ...initialState?.settings,
  };
};

/**
 * @name request 配置，可以配置错误处理
 * 它基于 axios 和 ahooks 的 useRequest 提供了一套统一的网络请求和错误处理方案。
 * @doc https://umijs.org/docs/max/request#配置
 */
export const request: RequestConfig = {
  ...errorConfig,
  requestInterceptors: [
    [
      (request: any) => {
        const authorization = sessionStorage.getItem('AUTHORIZATION');
        // console.log(request.url, request.method, authorization, request.url.indexOf('login') === -1);

        // 登录接口不需要 token
        if (authorization && request.url.indexOf(API_LOGIN) === -1) {
          request.headers.Authorization = authorization;
        }

        // 删除请求参数中的空值
        if (request.params && typeof request.params === 'object') {
          for (let key in request.params) {
            if (
              request.params[key] === undefined ||
              request.params[key] === null ||
              request.params[key] === ''
            ) {
              delete request.params[key];
            }
          }
        }

        return request;
      },
      (error: any) => Promise.reject(error),
    ],
  ],

  responseInterceptors: [
    [
      (response: any) => {
        if (Number(response.data.code) !== 0) {
          // 未登录
          if(Number(response.data.code) === -1001) {
            history.push(LOGIN_PATH);
          }

          return Promise.reject({
            code: Number(response.data.code),
            message: response.data.message,
          });
        }
        return response;
      },
    ],
  ],
};
